import { appUser } from 'features/common/fetch/beEndpoints';

export const FETCH_USER_INFO_PATH = `${appUser}.userInfo`;
export const FETCH_REPRESENTED_USER_INFO_PATH = `${appUser}.representedUserInfo`;

export const URLS_ACTIONS = {
	save_urls: 'save_urls',
};

export const URL_REDUCER_NAME = 'urls';
export const LOADER_REDUCER_NAME = 'iascLoader';

export const LOADER_ACTIONS = {
	set_loader_active: `${LOADER_REDUCER_NAME}/SET_ACTIVE`,
	set_loader_inactive: `${LOADER_REDUCER_NAME}/SET_INACTIVE`,
};

export const STATUS = {
	active: 'active',
	inactive: 'inactive',
};

export const MIGRATION_IN_PROGRESS_CODE = 998000032;
